export {Role}

const Role = {
    Referee: "Referee",
    Assigner: "Assigner",
    Owner: "Owner"
};
